import * as React from 'react';
export const OfficeIconImage = (props)=>{
    return /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        viewBox: "0 0 124 128",
        preserveAspectRatio: "none",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#OfficeIcon_svg__pattern180)",
        style: {
            mixBlendMode: 'multiply'
        },
        opacity: 0.2,
        d: "M29.411 94.511h82.305v32.55H29.411z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M38.614 94.938a6.239 6.239 0 00-3.08 11.625l22.01 12.477a12.008 12.008 0 005.948 1.569c1.122 0 2.238-.164 3.313-.484l33.112-9.436a11.852 11.852 0 008.583-11.373v-4.378z",
        style: {
            mixBlendMode: 'multiply'
        },
        opacity: 0.04
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#OfficeIcon_svg__pattern175)",
        style: {
            mixBlendMode: 'multiply'
        },
        opacity: 0.12,
        d: "M31.213 93.988h78.585v28.365H31.213z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M38.614 94.938a6.24 6.24 0 00-3.08 11.625l22.01 12.477a12.008 12.008 0 005.948 1.569c1.122 0 2.238-.164 3.313-.484l33.112-9.436a11.853 11.853 0 008.583-11.373v-4.378z",
        style: {
            mixBlendMode: 'multiply'
        },
        opacity: 0.014
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#OfficeIcon_svg__paint0_linear)",
        d: "M66.67 3.875l8.892 20.344v70.719l-8.757 25.187 33.112-9.436a11.852 11.852 0 008.583-11.373V24.684a11.836 11.836 0 00-8.603-11.393L66.67 3.875z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#OfficeIcon_svg__paint1_linear)",
        d: "M24.684 94.182l9.687-5.231a8.447 8.447 0 004.379-7.421V43.458a8.468 8.468 0 015.56-7.944L75.563 24.22v-8.583A12.245 12.245 0 0066.67 3.875a11.974 11.974 0 00-3.351-.465 12.42 12.42 0 00-6.084 1.608L21.467 25.42A11.819 11.819 0 0015.5 35.689v53.01a6.22 6.22 0 009.184 5.483z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#OfficeIcon_svg__paint2_linear)",
        d: "M75.562 94.938H38.614a6.239 6.239 0 00-3.08 11.625l22.01 12.477a12.008 12.008 0 005.948 1.569c1.122 0 2.238-.164 3.313-.484a12.053 12.053 0 008.757-11.625V94.937z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#OfficeIcon_svg__paint3_linear)",
        d: "M24.684 94.182l9.687-5.231a8.447 8.447 0 004.379-7.421V43.458a8.468 8.468 0 015.56-7.944L75.563 24.22v-8.583A12.245 12.245 0 0066.67 3.875a11.974 11.974 0 00-3.351-.465 12.42 12.42 0 00-6.084 1.608L21.467 25.42A11.819 11.819 0 0015.5 35.689v53.01a6.22 6.22 0 009.184 5.483z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#OfficeIcon_svg__paint4_linear)",
        d: "M75.562 94.938H38.614a6.239 6.239 0 00-3.08 11.625l22.01 12.477a12.008 12.008 0 005.948 1.569c1.122 0 2.238-.164 3.313-.484a12.053 12.053 0 008.757-11.625V94.937z"
    }), /*#__PURE__*/ React.createElement("defs", {
        id: "OfficeIcon_svg__defs164"
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        y2: 111.988,
        x2: 87.575,
        y1: -2.751,
        x1: 87.575,
        id: "OfficeIcon_svg__paint0_linear"
    }, /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop123",
        stopColor: "#FFB900"
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop125",
        stopColor: "#EF8400",
        offset: 0.17
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop127",
        stopColor: "#E25C01",
        offset: 0.31
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop129",
        stopColor: "#DB4401",
        offset: 0.43
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop131",
        stopColor: "#D83B01",
        offset: 0.5
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        y2: 88.059,
        x2: 6.123,
        y1: 1.298,
        x1: 66.882,
        id: "OfficeIcon_svg__paint1_linear"
    }, /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop134",
        stopColor: "#800600"
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop136",
        stopColor: "#C72127",
        offset: 0.6
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop138",
        stopColor: "#C13959",
        offset: 0.73
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop140",
        stopColor: "#BC4B81",
        offset: 0.85
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop142",
        stopColor: "#B95799",
        offset: 0.94
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop144",
        stopColor: "#B85BA2",
        offset: 1
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        y2: 107.783,
        x2: 115.165,
        y1: 107.783,
        x1: 35.844,
        id: "OfficeIcon_svg__paint2_linear"
    }, /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop147",
        stopColor: "#F32B44"
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop149",
        stopColor: "#A4070A",
        offset: 0.6
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        y2: 17.902,
        x2: 55.258,
        y1: -0.465,
        x1: 68.123,
        id: "OfficeIcon_svg__paint3_linear"
    }, /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop152",
        stopOpacity: 0.4
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop154",
        stopOpacity: 0,
        offset: 1
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        y2: 106.466,
        x2: 54.231,
        y1: 109.566,
        x1: 89.745,
        id: "OfficeIcon_svg__paint4_linear"
    }, /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop157",
        stopOpacity: 0.4
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "OfficeIcon_svg__stop159",
        stopOpacity: 0,
        offset: 1
    })), /*#__PURE__*/ React.createElement("pattern", {
        id: "OfficeIcon_svg__pattern180",
        xlinkHref: "#OfficeIcon_svg__pattern0"
    }), /*#__PURE__*/ React.createElement("pattern", {
        id: "OfficeIcon_svg__pattern175",
        xlinkHref: "#OfficeIcon_svg__pattern1"
    }), /*#__PURE__*/ React.createElement("pattern", {
        height: 1,
        width: 1,
        patternContentUnits: "objectBoundingBox",
        id: "OfficeIcon_svg__pattern0"
    }, /*#__PURE__*/ React.createElement("use", {
        id: "OfficeIcon_svg__use117",
        transform: "scale(.00562 .01408)",
        xlinkHref: "#OfficeIcon_svg__image0"
    })), /*#__PURE__*/ React.createElement("pattern", {
        height: 1,
        width: 1,
        patternContentUnits: "objectBoundingBox",
        id: "OfficeIcon_svg__pattern1"
    }, /*#__PURE__*/ React.createElement("use", {
        id: "OfficeIcon_svg__use120",
        transform: "scale(.00588 .01613)",
        xlinkHref: "#OfficeIcon_svg__image1"
    }))));
};
